import Icon from "@mui/icons-material/East";

export default function SendersIcon(props) {
	return <Icon color={props.color} fontSize={props.fontSize || "medium"} />;
}
